(function () {
  'use strict';

  // Removes "(Trial)" products from all predictive search dropdowns.
  // Works on both mobile inline search and desktop modal search.

  var TRIAL_MARKER = '(Trial)';

  function stripTrialItems(container) {
    container.querySelectorAll('li').forEach(function (li) {
      if (li.textContent.indexOf(TRIAL_MARKER) !== -1) {
        li.remove();
      }
    });
  }

  var searchObserver = new MutationObserver(function (records) {
    records.forEach(function (r) {
      var ps = r.target.closest
        ? r.target.closest('[data-predictive-search]')
        : null;
      if (!ps && r.target.dataset && r.target.dataset.predictiveSearch !== undefined) {
        ps = r.target;
      }
      if (ps) stripTrialItems(ps);
    });
  });

  function attachToContainers() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (el) {
      searchObserver.observe(el, { childList: true, subtree: true });
    });
  }

  // Watch for desktop modal being injected into the DOM after page load
  var domObserver = new MutationObserver(attachToContainers);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachToContainers();
      domObserver.observe(document.body, { childList: true });
    });
  } else {
    attachToContainers();
    domObserver.observe(document.body, { childList: true });
  }
})();
